<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">申请License</div>
    <div slot="body">
      <a-form :form="form.fc">
        <!-- <a-form-item label="License类型" v-bind="formItemLayout">
          <a-radio-group v-decorator="decorators.used_for" @change="handleTypeDescRadioChange">
            <a-radio value="community" :style="radioStyle">
              不限时间试用
            </a-radio>
            <label class="desc">该类型可永久免费试用，授权配额为宿主机6个CPU插槽，另可管理公有云虚拟机50台</label>
            <a-tooltip placement="top" :title="testExceeded ? '试用数量限制为1个' : ''">
              <a-radio value="test"  :style="radioStyle" :disabled="testExceeded">
                不限配额试用
              </a-radio>
            </a-tooltip>
            <label class="desc">该类型不限资源数量，免费试用期为30天。每个注册账号和每个服务器识别码只允许申请一次，到期后，可申请另一种类型继续试用或联系我们进行定制</label>
          </a-radio-group>
        </a-form-item> -->
        <!-- <a-form-item label="企业名称" v-bind="formItemLayout">
          {{ enterpriseName }}
          <a-tooltip :title="disableEdit ? '您已提交过企业认证，修改请到控制台企业信息认证界面提交认证信息' : ''">
            <a-button class="ml-2" type="link" icon="edit" size="small" @click="editEnterpriseName" :disabled="disableEdit" />
          </a-tooltip>
        </a-form-item> -->
        <a-form-item label="服务器识别码" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.service_num" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
        <a-form-item label="到期时间" v-bind="formItemLayout">
          {{ expireTime }}
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CustomApplyLicenseDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        // used_for: [
        //   'used_for',
        //   {
        //     initialValue: this.$store.state.app.customerCapability.license_quotas.test.exceeded ? 'community' : 'test',
        //   },
        // ],
        service_num: [
          'service_num',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请输入服务器识别码' },
              { validator: this.checkServiceNum },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px',
      },
      // usedFor: this.$store.state.app.customerCapability.license_quotas.test.exceeded ? 'community' : 'test',
      // typeDesc: this.$store.state.app.customerCapability.license_quotas.test.exceeded ? '社区版License永久有效，授权管理的宿主机6节点，虚拟机50台' : '商业试用版License授权宿主机10000台和虚拟机数量100000台，每个注册账号、每个服务器识别码只允许申请一次。此License的有效期为30天，到期后，可申请社区版License继续试用或联系客服电话010-64361972',
    }
  },
  computed: {
    ...mapState('app', {
      testExceeded: state => state.customerCapability.license_quotas.test.exceeded,
      enterpriseInfo: state => state.enterpriseInfo,
      certifiedStatus: state => state.customerCapability.certified_status,
    }),
    expireTime () {
      if (this.usedFor === 'test') return this.$moment().add(30, 'days').format('YYYY-MM-DD')
      return '2099-12-30'
    },
    enterpriseName () {
      const info = this.$store.state.app.enterpriseInfo
      return info && info.name ? info.name : '-'
    },
    disableEdit () {
      if (this.certifiedStatus === 'uncertified') return false
      return true
    },
  },
  methods: {
    editEnterpriseName () {
      this.createDialog('EditEnterpriseNameDialog')
    },
    handleTypeDescRadioChange (e) {
      this.usedFor = e.target.value
      if (e.target.value === 'community') this.typeDesc = '社区版License永久有效，授权管理的宿主机6节点，虚拟机50台'
      else this.typeDesc = '商业试用版License授权宿主机10000台和虚拟机数量100000台，每个注册账号、每个服务器识别码只允许申请一次。此License的有效期为30天，到期后，可申请社区版License继续试用或联系客服电话010-64361972'
    },
    checkServiceNum (rule, value, callback) {
      if (value.length < 32) {
        const error = '服务器识别码长度必须32位以上'
        return callback(error)
      }
      return callback()
    },
    doApply (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        values.service_num = values.service_num.replace(/\n/g, ',')
        values.used_for = 'community_zjydjc'
        await this.doApply({ ...values, expire: this.expireTime, service_type: 'compute', licensee: this.enterpriseName })
        this.loading = false
        this.cancelDialog()
        this.$message.success('操作成功')
        this.$store.dispatch('app/getCustomerCapabilities')
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .desc {
    color: rgba(0, 0, 0, 0.45);
  }
</style>
